import { Pipe, PipeTransform } from '@angular/core';
import { OperationTypeByAPIMap } from '@common/constants';

@Pipe({
  name: 'operationTypeToDisplayName',
  pure: true
})
export class OperationTypeToDisplayNamePipe implements PipeTransform {
  transform(key: string): string {
    return OperationTypeByAPIMap[key]?.displayName || '';
  }
}
